import type React from "react";
import { useState } from "react";

import {
  DEFAULT_VALUES_OBJECT,
  ScrollContext,
  type Values,
} from "./useScrollContext";

export type { Values } from "./useScrollContext";

type ScrollProviderProps = {
  children: React.ReactNode;
};

const ScrollProvider: React.FC<ScrollProviderProps> = ({ children }) => {
  const [isScrolledAboveFold, setIsScrolledAboveFold] = useState(true);
  const [values, setValues] = useState<Values>(DEFAULT_VALUES_OBJECT);

  return (
    <ScrollContext.Provider
      value={[
        { isScrolledAboveFold, values },
        { setIsScrolledAboveFold, setValues },
      ]}
    >
      {children}
    </ScrollContext.Provider>
  );
};

export default ScrollProvider;
